class VatRateSearchController extends BaseSearchController
	@register angular.module 'App.Module.Controller'

	getSearchQuery: ->
		query = do super
		query.with 'price_region'

		return query

	afterSearch: (response, isManualSubmit = false, appendResult = true) ->
		super arguments...

		for own i, item of @searchItems.items
			item.percentageText = @searchData.repository.getPercentageText(item.percentage)
